export default function classList(...classNames) {

	function list() {
		return classNames.filter(className => !!className).join(' ')
	}

	list.add = function (...newClassNames) {
		newClassNames.forEach(className => {
			if (!!className && !classNames.includes(className))
			classNames.push(className)
		})

		return list
	}

	list.remove = function (...removeClassNames) {
		removeClassNames.forEach(className => {
			const index = classNames.indexOf(className)
			if (index !== -1)
				classNames.splice(index, 1)
		})

		return list
	}

	list.replace = function (oldClassName, newClassName) {
		const index = classNames.indexOf(oldClassName)
		if (index !== 1)
			classNames.splice(index, 1, newClassName)
		return list
	}

	return list
}

/**
 * Usage:
 *
 * import classList from 'classList.js'
 *
 * const className = classList('SomeComponentClass', 'red', 'bold')
 * className.add('underline')
 * className.remove('red')
 * className.replace('bold', 'italic')
 *
 * return <SomeComponentClass class={className()} />
 */
